export const RIGHT_PANEL_WIDTH = 390;
export const RIGHT_PANEL_COLLAPSED_WIDTH = 58;
